import { Status } from '../../shared/base/course-lecture-status';
import { ModelBase } from '../../shared/base/model-base';
import { ObjectObservable } from '../../shared/base/object-observable';
import { User } from '../../users/shared/user';
import {Syllabus} from "../../syllabuses/shared/syllabus";

export class Course extends ModelBase {
  name: string;
  status?: Status;
  billing = true;
  description?: string;
  syllabus?: Syllabus;
  coverUrl?: string;
  owner?: string;
  slackUrl?: string;
  ownerObservable?: ObjectObservable<User>;

  constructor() {
    super();
    if (this.isInProgress()) {
      this.status = Status.INPROGRESS;
    }
  }

  changeBilling(value: boolean) {
    this.billing = value;
  }

  isBilling(): boolean {
    return this.billing === undefined || this.billing;
  }

  isInProgress(): boolean {
    return this.status === undefined || this.status === Status.INPROGRESS;
  }
}





// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/shared/course.ts